import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import MaterialsViewer from './MaterialsViewer';
import ResultViewer from './ResultViewer';
import StackupEditor from './StackupEditor';
import BottomNav from './BottomNav';

export class ViewerComponent extends Component {
  render() {
    const { classes, layers, url } = this.props;
    const hasLayers = layers !== undefined && layers.length > 0;

    return hasLayers ? (
      <div className={classes.root}>
        <Switch>
          <Route exact path={`${url}/simulations`} component={ResultViewer} />
          <Route exact path={`${url}/materials`}   component={MaterialsViewer} />
          <Route exact path={`${url}/`}            component={StackupEditor} />
        </Switch>
        <BottomNav path={window.location.pathname} />
      </div>
    ) : (
      <Redirect to={{ pathname: `${url}/new` }} />
    );
  }
}

ViewerComponent.propTypes = {
  classes:        PropTypes.object.isRequired,
  url:            PropTypes.string.isRequired,
  layers:         PropTypes.array,
};

export default ViewerComponent;



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ViewerComponent.js